module.exports = __webpack_public_path__ + "static/DSC02112-f6c65041c3979c255ff423c763c80a2f.png";